<template>
  <div
    class="Fuell-Table--row"
    :style="tableGridTemplateStyle"
  >
    <template v-for="column in columns">
      <div
        v-if="column.visible && column.key === COLUMNS.USER"
        :key="column.key"
        v-tooltip="cardNameAndLastName"
        class="Fuell-Table--item clickable"
        @click="emitShowCardDetail"
      >
        <div class="flex dark">
          <user-name-badge
            :userName="cardNameAndLastName"
            :userAvatarId="cardProfilePictureId"
          ></user-name-badge>
          <span class="ellipsis">{{ cardNameAndLastName }}</span>
        </div>
      </div>
      <div
        v-if="column.visible && column.key === COLUMNS.PAN"
        :key="column.key"
        class="Fuell-Table--item clickable"
        v-tooltip="cardPartialPan"
        @click="emitShowCardDetail"
      >
        <span v-if="!cardPending">{{cardPartialPan}}</span>
        <span
          class="text-center w-100"
          v-else
        >-</span>
      </div>
      <div
        class="Fuell-Table--item clickable"
        v-tooltip="cardAlias"
        v-if="column.visible && column.key === COLUMNS.ALIAS"
        :key="column.key"
        @click="emitShowCardDetail"
      >
        <span
          class="ellipsis"
          v-if="!cardPending"
        >
          {{cardAlias}}
        </span>
        <span
          class="w-100 text-center"
          v-else
        >-</span>
      </div>
      <div
        v-if="column.visible && column.key === COLUMNS.BUDGET"
        :key="column.key"
        class="Fuell-Table--item clickable"
        v-tooltip="cardBudget"
        @click="emitShowCardDetail"
      >
        <span v-if="!cardPending">
          {{ cardBudget }}
        </span>
        <span
          class="w-100 text-center"
          v-else
        >-</span>

      </div>
      <div
        v-if="column.visible && column.key === COLUMNS.STATUS"
        :key="column.key"
        class="Fuell-Table--item clickable"
        v-tooltip="cardStatusTooltip(card.status.code)"

      >
        <toggle-switch
          v-if="!cardPending"
          :status="cardSwitchStatus"
          :negativeLabelClass="negativeLabelClass"
          :switchClass="switchClass"
          :sphereClass="sphereClass"
          negative-label="card_status__ACTIVE"
          useLabelSlot
          updateOnChange
          @change="checkPassCode"
        >
          <template slot="label">
            <span
              v-if="card && card.status && card.status.code === 'FROZEN_BY_ADMIN'"
              :class="labelClass"
            >{{$t('card_status__FROZEN')}} <img
                class="card-locked-icon"
                alt="card-locked-icon"
                :src="
                    require(`@/assets/img/icons/icon-lock-warning.svg`)
                  "
              /></span>
            <span
              v-else
              :class="labelClass"
            >{{$t('card_status__FROZEN')}}</span>
          </template>
        </toggle-switch>
        <span v-else>
          {{$t('card_not_generated')}}
        </span>
      </div>
      <div
        v-if="column.visible && column.key === COLUMNS.OPTIONS"
        :key="column.key"
        class="Fuell-Table--item Fuell-Table--options Fuell-Dropdown--button-dots"
      >
        <button
          @click="emitShowCardDetail"
          class="Fuell-IconButton Fuell-IconButton--no-margin Fuell-IconButton--fixed-width dots"
        >
          <img
            :src="require(`@/assets/img/icons/icon-dots.svg`)"
            alt="options"
          />
        </button>
      </div>
    </template>
    <confirm-modal
      v-if="showFrozenCardModalFlag"
      :open.sync="showFrozenCardModalFlag"
      :modalClass="'ModalBox--400'"
      :title="'card_frozen_modal_title'"
      :message="'card_frozen_modal_description'"
      :acceptText="'card_frozen_modal_frozen'"
      :dismissText="'ACTION_CANCEL'"
      acceptBtnClass="blue"
      dismissBtnClass="danger"
      closeButton
      @accept="adminUnfreezeCard"
      @dismiss="closeModal"
    ></confirm-modal>
  </div>
</template>

<script>
import { COLUMNS } from '@/modules/cards/_constants/Columns'
import UserNameBadge from '@/components/Commons/UserNameBadge'
import ToggleSwitch from '@/components/Commons/Forms/ToggleSwitch'
const ConfirmModal = () => import('@/components/Commons/ConfirmModal')

export default {
  name: 'CardsTableRow',
  components: {
    UserNameBadge,
    ToggleSwitch,
    ConfirmModal
  },
  props: {
    card: {
      type: Object,
      required: true
    },
    columns: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      showFrozenCardModalFlag: false
    }
  },
  computed: {
    isAdmin () {
      return this.$store.getters['LoginStore/isAdmin']
    },
    isSuperAdmin () {
      return this.$store.getters['LoginStore/isSuperAdmin']
    },
    tableGridTemplateStyle () {
      let columns = this.columns.map(c => c.template)
      return {
        gridTemplateColumns: columns.join(' ')
      }
    },
    COLUMNS () {
      return COLUMNS
    },
    cardNameAndLastName () {
      return this.card &&
        this.card.user
        ? `${this.card.user.firstName} ${this.card.user.lastName}`
        : ''
    },
    cardProfilePictureId () {
      return this.card.user && this.card.user.profilePicture
        ? this.card.user.profilePicture.id
        : 0
    },
    cardAlias () {
      return this.card?.alias
    },
    cardBudget () {
      return this.card?.assignedBudget?.name
    },
    cardPartialPan () {
      return this.card?.partialPAN ? `·· ${this.card?.partialPAN}` : ''
    },
    cardStatus () {
      return this.card?.status?.code
    },
    cardPending () {
      return this.cardStatus === 'PENDING'
    },
    cardSwitchStatus () {
      return this.card?.status?.code === 'FROZEN' || this.card?.status?.code === 'FROZEN_BY_ADMIN'
    },
    negativeLabelClass () {
      return this.card?.status?.code === 'FROZEN' || this.card?.status?.code === 'FROZEN_BY_ADMIN' ? 'disabled mr-2' : 'active-card mr-2'
    },
    labelClass () {
      return this.card?.status?.code === 'FROZEN' || this.card?.status?.code === 'FROZEN_BY_ADMIN' ? 'frozen-card ml-2' : 'disabled ml-2'
    },
    switchClass () {
      return this.card?.status?.code === 'FROZEN' || this.card?.status?.code === 'FROZEN_BY_ADMIN' ? 'frozen-card-switch' : 'active-card-switch'
    },
    sphereClass () {
      return this.card?.status?.code === 'FROZEN' || this.card?.status?.code === 'FROZEN_BY_ADMIN' ? 'frozen-card-sphere' : 'active-card-sphere'
    }
  },
  methods: {
        cardStatusTooltip (cardStatus) {
      if (cardStatus === 'FROZEN') {
        return this.$t('card_status__FROZEN_tooltip')
      }
      if (cardStatus === 'FROZEN_BY_ADMIN') {
        return this.$t('card_status__FROZEN_BY_ADMIN')
      }

      return this.$t(`card_status__${cardStatus}`)
    },

    closeModal () {
      this.showFrozenCardModalFlag = false
    },
    emitShowCardDetail () {
      this.$emit('showCardDetailModal', this.card.id)
    },
    async checkPassCode () {
      if (this.card.status?.code === 'ACTIVE' && (this.isAdmin || this.isSuperAdmin)) {
        this.showFrozenCardModalFlag = true
      } else if (this.card.status?.code === 'ACTIVE') {
        await this.$store.dispatch('CardsStore/freezeCard', {
          cardId: this.card.id,
          passcode: this.card.passcode,
          cardInfo: this.card
        })
      } else if (this.card.status?.code === 'FROZEN') {
        await this.$store.dispatch('CardsStore/activateCard', {
          cardId: this.card.id,
          passcode: this.card.passcode,
          cardInfo: this.card
        })
      } else if (this.card.status?.code === 'FROZEN_BY_ADMIN' && (this.isAdmin || this.isSuperAdmin)) {
        await this.$store.dispatch('CardsStore/activateCard', {
          cardId: this.card.id,
          passcode: this.card.passcode,
          cardInfo: this.card
        })
      }
    },
    async adminUnfreezeCard () {
      await this.$store.dispatch('CardsStore/freezeCard', {
        cardId: this.card.id,
        passcode: this.card.passcode,
        cardInfo: this.card
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.spinner-loading >>> .py-4 {
  height: 24px;
  width: 24px;
  line-height: 24px;
  padding: 0px !important;
}
.Fuell-Table--row {
grid-gap:30px;
}
</style>
<style lang="scss">
.frozen-card {
  color: var(--semantic-alert-main);
}
.frozen-card-switch {
  background-color: var(--semantic-alert-tint);
}

.card-locked-icon {
  margin-left: 20px;
}

.frozen-card-sphere {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  position: absolute;
  right: 2px;
  background-color: var(--semantic-alert-main);
}

.active-card {
  color: var(--semantic-brand-main);
}

.active-card-switch {
  background-color: var(--semantic-brand-tint);
}

.active-card-sphere {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  position: absolute;
  left: 2px;
  background-color: var(--semantic-brand-main);
}

.disabled {
  color: var(--text-disabled);
}

</style>
